import { render, staticRenderFns } from "./NeoInterpretation.vue?vue&type=template&id=66df3e30&scoped=true&"
import script from "./NeoInterpretation.vue?vue&type=script&lang=js&"
export * from "./NeoInterpretation.vue?vue&type=script&lang=js&"
import style0 from "./NeoInterpretation.vue?vue&type=style&index=0&id=66df3e30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df3e30",
  null
  
)

export default component.exports